<template>
    <div v-scroll="handleScroll" class="products-container w-100">
        <div class="products-grid">
            <div v-for="(st,n) in itemsToDisplay" :key="st.id || n" class="product-item">
                <product :class="['product-'+ n, 'w-100', 'h-100']"   
                    :product="st" 
                    :scroll="scroll"
                    @open-detail="openProductDetail"
                    @open-zoom="openProductZoom"
                />
            </div>
        </div>

        <!-- Global modal outside card context -->
        <custom-producto 
          :modalp="modalOpen" 
          :producto="selectedProduct" 
          @cerrarModalp="modalOpen = false">
        </custom-producto>

        <!-- Modal Exclusivo de Zoom / Vista Ampliada -->
        <zoom-imagen 
          :modalz="zoomModalOpen" 
          :producto="zoomProducto" 
          :imagenes="zoomImagenes" 
          :scroll="scroll" 
          @cerrarModalz="zoomModalOpen = 0">
        </zoom-imagen>
    </div>
</template>

<script>
import Vue from 'vue';

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})
    import Product from './Product.vue'
    import customProducto from './customProducto.vue'
    import ZoomImagen from './ZoomImagen.vue'
    import { mapState} from 'vuex'

    export default {
        props:['limit', 'items', 'gridClass'],
        name: 'Products',
        components: {
            Product,
            'custom-producto': customProducto,
            'zoom-imagen': ZoomImagen
        },
        data() {
            return {
                data: null,
                sortBy:null,
                id:null, 
                fixed:0,
                scroll:0,
                modalOpen: false,
                selectedProduct: {},
                zoomModalOpen: 0,
                zoomProducto: {},
                zoomImagenes: [],
                dominio: this.$store.state.dominio
            }
        },
        computed : {
            ...mapState(['sliderFilter','filterCat','stock',
            'orderPrice','orderAvailable','orderQuantity','sorted']),
            validItems() {
                let list = this.items || this.sorted;
                if (!Array.isArray(list)) return [];
                return list.filter(st => this.esValido(st));
            },
            itemsToDisplay() {
                let list = this.validItems;
                if (this.limit) {
                    return list.slice(0, this.limit);
                }
                return list;
            }
        },
        methods: {
            esValido(st) {
                if (!st) return false;
                if (st.imagenes && Array.isArray(st.imagenes) && st.imagenes.length > 0) {
                    return st.imagenes.some(img => {
                        let name = typeof img === 'string' ? img : (img && img.nombre);
                        return name && name !== 'noimagen' && name.trim() !== '';
                    });
                }
                if (st.imagen && typeof st.imagen === 'string' && st.imagen !== 'noimagen' && st.imagen.trim() !== '') {
                    return true;
                }
                return false;
            },
             handleScroll: function () {
                this.scroll=window.scrollY
                if (window.scrollY > 80) {
                    this.fixed=1
                }else{
                    this.fixed=0
                }
                
            },
            filterBy(product,n = 1) {
                var flag = true
                if(this.filterCat) {
                    flag = product.idcategoria == this.filterCat
                } 
                if(!(product.precio_venta <= this.sliderFilter[1] && product.precio_venta >= this.sliderFilter[0])) {
                    flag = false
                }
                if(!product.condicion && this.available){
                    flag = false
                }
                if(product.stock > this.stock){
                    flag = false
                }
                
                if(this.limit <=  n ){
                    flag = false
                }
                
                return flag
            },
            openProductDetail(product) {
                this.selectedProduct = product;
                this.modalOpen = true;
            },
            openProductZoom(product) {
                this.zoomProducto = product;
                this.zoomImagenes = (product && product.imagenes) ? product.imagenes : [];
                this.zoomModalOpen = 1;
            }
        },
        mounted() {
            this.id=this.$route.params.id
        }
    }
</script>

<style scoped>
.products-container {
    width: 100%;
}
.products-grid {
    display: grid !important;
    grid-template-columns: repeat(4, 1fr) !important;
    gap: 16px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
}

.product-item {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
    min-width: 0 !important;
}

@media (max-width: 1199.98px) {
    .products-grid {
        grid-template-columns: repeat(3, 1fr) !important;
        gap: 14px !important;
    }
}

@media (max-width: 767.98px) {
    .products-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 10px !important;
    }
}

@media (max-width: 480px) {
    .products-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 8px !important;
    }
}

.title-producto{
    margin-bottom: 0;
    font-size: 18px;
}
.productinfo figure{
    margin:0;
}
.datos-producto{
    font-size: 12px;
}
</style>